export default function Terms() {
  return (
    <div>
      <h2>Terms of Service</h2>

      <p>
        This application is provided for personal use only and is not intended
        for commercial use.
      </p>

      <p>
        The application is provided “as is” without warranties of any kind,
        express or implied.
      </p>

      <p>
        This application does not provide financial, legal, or tax advice.
        Decisions made using this application are the sole responsibility of the
        user.
      </p>

      <p>
        Use of this application is at your own risk. Access may be revoked at any
        time.
      </p>
    </div>
  );
}
